module.exports = {"TXTWCL_Total_you_receive":{"id":"TXTWCL_Total_you_receive","defaultMessage":"Ukupno što ćete dobiti"}}